import React from 'react';
import './Projects.css';
import camsta from '../../Images/camsta.png';
import holiday from '../../Images/holiday.png';
import gym from '../../Images/gym.png';
import musician from '../../Images/musician.png';

const Projects = () => {

    const projects = [
        {
            img: camsta,
            projectName: 'Camsta',
            type: 'E-commerce website',
            details: 'This is the action camera shop-related an E-commerce website where customers can purchase many action cameras.',
            liveLink: 'https://camsta-actioncam.web.app/',
            gitClientLink: 'https://github.com/ankan-782/Camsta-client-side',
            gitServerLink: 'https://github.com/ankan-782/Camsta-server-side',
        },
        {
            img: holiday,
            projectName: 'Holiday Planners',
            type: 'Tourism-related website',
            details: 'This is a travel-agency-related website where customers books many travel package.',
            liveLink: 'https://holiday-planner-bac0a.web.app/',
            gitClientLink: 'https://github.com/ankan-782/Holiday-Planners-client-side',
            gitServerLink: 'https://github.com/ankan-782/Holiday-Planners-server-side',
        },
        {
            img: gym,
            projectName: 'Gym-Nation',
            type: 'Healthcare-related website',
            details: 'This is the gym-workout fitness-related website where trainers do different classes and users learn about many workouts and see details about classes related information trainer-related information.',
            liveLink: 'https://gymnation-73ac6.web.app/',
            gitClientLink: 'https://github.com/ankan-782/Gym-nation',
            gitServerLink: '',
        },
        {
            img: musician,
            projectName: 'Musician',
            type: 'Education-related website',
            details: 'This is a music-teaching-related website where users can buy many musical courses.',
            liveLink: 'https://musician-782.netlify.app/',
            gitClientLink: 'https://github.com/ankan-782/Musician',
            gitServerLink: '',
        }
    ]

    return (
        <div id="projects">
            <div className="projects section-container">
                <div className="projects-header">
                    <h1 className="section-title">Recent <span>Projects</span></h1>
                </div>
                <div className="all-projects">
                    {
                        projects.map(project => <div className="project-item">
                            <div className="project-info">
                                <h1>{project.projectName}</h1>
                                <h2>{project.type}</h2>
                                <p>{project.details}</p>
                                <div className="projects-link">
                                    <div className='d-flex align-content-center mb-2'>
                                        <i className="fa-solid fa-circle-arrow-right fs-4"></i>
                                        <a className='ms-2' href={project.liveLink}>Live Site Link</a>
                                    </div>
                                    <div className='d-flex align-content-center mb-2'>
                                        <i className="fa-solid fa-circle-arrow-right fs-4"></i>
                                        <a className='d-inline ms-2' href={project.gitClientLink}>Github Client Side Link</a>
                                    </div>
                                    <div className='d-flex align-content-center'>
                                        <i className="fa-solid fa-circle-arrow-right fs-4"></i>
                                        <a className='d-inline ms-2' href={project.gitServerLink ? project.gitServerLink : ''}>Github Server Side Link</a>
                                    </div>
                                </div>
                            </div>
                            <div className="project-img">
                                <img src={project.img} alt="img" />
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Projects;